import { Box, useMediaQuery } from "@mui/material";
import React from "react";
import bottom from "./assets/homebottom2.png";

function HeadBottom() {
  const check = useMediaQuery("(max-width:1200px)");
  const hide = useMediaQuery("(max-width:1040px)");
  return (
    <div>
      <Box
        mt={hide ? "0px" : check ? "-400px" : "-580px"}
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        zIndex="-1"
      >
        <img
          className="bottom"
          src={bottom}
          style={{
            width: "100%",
            maxWidth: "100%",
            maxHeight: "85vh",
            position: "relative",
          }}
          alt=""
        />
      </Box>
    </div>
  );
}

export default HeadBottom;
